import React from 'react'
import classnames from 'classnames'
import { PlusIcon } from '@myxplor/icons'
import { FormButton } from '@myxplor/forms'
import { truncateDay } from '../../../../../../week'
import DaySessions from './day-sessions'

const WeekDay = ({
  day,
  sessions = [],
  nameBase,
  onChange,
  addKey,
  removeKey,
  sessionTemplate,
  isEditing,
  changeEditingSession,
  resetEditingSession,
  isWeekend,
  careEnrolmentOptions,
}) => (
  <div
    className={classnames({
      weekDay: true,
      weekDay__isWeekend: isWeekend,
      weekDay__isEditing: isEditing.today,
    })}>
    <h4>{truncateDay(day.label)}</h4>

    <ol>
      {sessions.map((session, i) => (
        <DaySessions
          key={i}
          session={session}
          onChange={onChange}
          removeKey={removeKey}
          nameBase={nameBase + `[${i}]`}
          changeEditingSession={() => changeEditingSession(i)}
          resetEditingSession={resetEditingSession}
          isEditing={isEditing.today && isEditing.sessionIndex === i}
          careEnrolmentOptions={careEnrolmentOptions}
        />
      ))}
    </ol>

    <AddBooking
      day={day}
      onClick={() => {
        changeEditingSession(sessions.length)
        addKey(nameBase, sessionTemplate(sessions.length, { dayIndex: day.value }))
      }}
    />
  </div>
)

const AddBooking = ({ onClick, day }) => (
  <FormButton center className="weekDay--addSession" onClick={onClick}>
    <PlusIcon title={`Add session to ${day.label}`} />
  </FormButton>
)

export default WeekDay



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/update-enrolment-schedule/form/day.jsx